// extracted by mini-css-extract-plugin
module.exports = {"page":"item-page_page__1pezO","content":"item-page_content__2WI0P","buttons":"item-page_buttons__1OcAH","prevnext":"item-page_prevnext__2RsKh"};